import React, {useState, useEffect} from "react";
import {Modal, Button, Form, Tabs} from "antd";
import WarehouseIncomingCreate from "./WarehouseCreate";
import WarehouseMultiCreate from "./WarehouseMultiCreate";
import {getAllWarehouse} from "../../services/serviceWarehouse";

const createTypes = {
    single: '0',
    multi: '1'
}

const WarehouseCreateContainer = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm();
    const [createType, setCreateType] = useState(createTypes.single);
    const [activeTab, setActiveTab] = useState(createTypes.single);
    const [loadings, setLoadings] = useState(false);
    const [warehouseOptions, setWarehouseOptions] = useState([])

    useEffect(() => {
      getAllWarehouse()
      .then(({data}) => {
          let warehouses = []
          data.map(item => {
              let warehouse = {
                  text: `${item.code} - ${item.name}`,
                  value: item.id
              }
              warehouses.push(warehouse)
          })
          setWarehouseOptions(warehouses)
      })
    }, [])

    const modalCloseSignal = () => {
      modalCloser();
      updater();
    };

    const loadingSignal = (v) => setLoadings(v);

    const tabOptions = [
      {
        label: 'Tekli Giriş',
        key: '0',
        children: <WarehouseIncomingCreate modalCloseSignal={modalCloseSignal} warehouses={warehouseOptions}/>
      },
      {
        label: 'Toplu Giriş',
        key: '1',
        children: <WarehouseMultiCreate modalCloseSignal={modalCloseSignal} warehouses={warehouseOptions} loadSignal={loadingSignal}/>
      }
    ]

    const handleTabChange = (key) => {setActiveTab(key)}

    return(
        <React.Fragment>
            <Modal
             style={{minWidth: '50%'}}
             open={show}
             closable={false}
             title={'Depo Giriş Yap'}
             footer={[
                 <Button key={'CancelButton'} disabled={loadings} onClick={() => modalCloser()}>{loadings ? 'İşlem Yapılıyor' : 'Kapat'}</Button>
             ]}
            >
              <Tabs
                onChange={handleTabChange}
                type="card"
                defaultActiveKey="0"
                items={tabOptions}
              />
            </Modal>
        </React.Fragment>
    )
}

export default WarehouseCreateContainer;